import { Component, OnInit } from '@angular/core';
import { GlobalService } from 'src/app/global.service';
import { HttpService } from 'src/app/http.service';

@Component({
  selector: 'app-icustomer-type-wise-product-discount-trace-log',
  templateUrl: './icustomer-type-wise-product-discount-trace-log.component.html',
  styleUrls: ['./icustomer-type-wise-product-discount-trace-log.component.scss']
})
export class IcustomerTypeWiseProductDiscountTraceLogComponent implements OnInit {
  dataSource: Object;

  constructor(private global: GlobalService, private http: HttpService) {
    this.global.set_master_page_title = 'Icustomer typeWise Discount';
    this.http.getIcustomerTypeWiseProductDiscountTraceLog().subscribe((data)=> {
      this.dataSource = data
    })
   }

  ngOnInit() {
  }

}
